import { Link, useLocation } from 'react-router-dom'
import { isMobile} from "react-device-detect"
import MenuIcon from '@mui/icons-material/Menu';
import { useEffect, useState } from "react";

function Navigator(props)
{
    const loc = useLocation();
    const [dropdown, setDropdown] = useState(false);

    useEffect(() => {
        const itemNames = {
            "menu-item1": "/",
            "menu-item2": "/about",
            "menu-item3": "/philosophy",
            "menu-item4": "/contact"
        };

        for (const key in itemNames)
        {
            if (itemNames[key] === loc.pathname)
                document.getElementById(key).classList.add("selected-item");
            else
                document.getElementById(key).classList.remove("selected-item");
        }
    }, [loc]);

    const toggleMenu = () =>
    {
        setDropdown(!dropdown);
    }

    useEffect(() => {
        const menu = document.getElementById("menu");
        if (!dropdown)
            menu.classList.remove("is-show");
        else
            menu.classList.add("is-show");
    });
    const close = () => {
        setDropdown(false);
    }

    return(
        <div className="navigator">
            <div id="header">
              <div id="titles">
                 <div className='title'>
                      {"Digital Minhwa"}
                 </div>
                 <div className='subtitle'>
                    <dl>
                      <dt> Mordern Interpretation </dt>
                      <dt> of Korean Folk Art </dt>
                    </dl>
                 </div>
              </div>
              <div hidden={!isMobile}>
                <MenuIcon id="menuIcon" onClick={toggleMenu} className="img" fontSize="large" sx={{ color: "#000000"}}/>
              </div>
            </div>
            <div className="menu" id="menu" onClick={() => {close()}}>
                <Link className='menu-item' id="menu-item1" to='/'>
                    Gallery
                </Link>
                <Link className='menu-item' id="menu-item2" to='/about'>
                    About
                </Link>
                <Link className='menu-item' id="menu-item3" to='/philosophy'>
                    Artistic Philosophy
                </Link>
                <Link className='menu-item' id="menu-item4" to='/contact'>
                    Contact
                </Link>
            </div>
        </div>
    )
}
export default Navigator;
